import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ScheduleABForm from './ScheduleABForm';
import './ScheduleAB.less';
import MoneyFormat from '../common/MoneyFormat';
import EditCopyPasteSchedule from '../common/EditCopyPasteSchedule';
import ScheduleVerifyToolbar from '../common/ScheduleVeriyToolbar';

const BLANK_FORM_DATA = {
  acct_rcpt: 0,
  cash: 0,
  deposits: 0,
  farming: 0,
  intangibles: 0,
  inventory: 0,
  investments: 0,
  machinery: 0,
  office: 0,
  others: 0,
  property: 0,
};

class ScheduleAB extends Component {
  getScheduleABdata = (data) => {
    const rows = (
      <React.Fragment>
        <tbody>
          <tr className="odd">
            <td>
              <span className="label">Cash, cash equivalents, and financial assets.</span>
              <span className="schedule-tips">Copy line 5, Part 1</span>
            </td>
            <td className="money" id="cash">
              {MoneyFormat(data.cash)}
            </td>
            <td />
          </tr>
          <tr className="even">
            <td>
              <span className="label">Deposits and prepayments.</span>
              <span className="schedule-tips">Copy line 9, Part 2</span>
            </td>
            <td className="money" id="deposits">
              {MoneyFormat(data.deposits)}
            </td>
            <td />
          </tr>
          <tr className="odd">
            <td>
              <span className="label">Accounts receivable.</span>
              <span className="schedule-tips">Copy line 12, Part 3</span>
            </td>
            <td className="money" id="acct-rcpt">
              {MoneyFormat(data.acct_rcpt)}
            </td>
            <td />
          </tr>
          <tr className="even">
            <td>
              <span className="label">Investments.</span>
              <span className="schedule-tips">Copy line 17, Part 4</span>
            </td>
            <td className="money" id="investments">
              {MoneyFormat(data.investments)}
            </td>
            <td />
          </tr>
          <tr className="odd">
            <td>
              <span className="label">Inventory.</span>
              <span className="schedule-tips">Copy line 23, Part 5</span>
            </td>
            <td className="money" id="inventory">
              {MoneyFormat(data.inventory)}
            </td>
            <td />
          </tr>
          <tr className="even">
            <td>
              <span className="label">Farming and fishing-related assets.</span>
              <span className="schedule-tips">Copy line 33, Part 6</span>
            </td>
            <td className="money" id="farming">
              {MoneyFormat(data.farming)}
            </td>
            <td />
          </tr>
          <tr className="odd">
            <td>
              <span className="label">Office furniture, fixtures, and equipment; and collectibles.</span>
              <span className="schedule-tips">Copy line 43, Part 7</span>
            </td>
            <td className="money" id="office">
              {MoneyFormat(data.office)}
            </td>
            <td />
          </tr>
          <tr className="even">
            <td>
              <span className="label">Machinery, equipment, and vehicles.</span>
              <span className="schedule-tips">Copy line 51, Part 8</span>
            </td>
            <td className="money" id="machinery">
              {MoneyFormat(data.machinery)}
            </td>
            <td />
          </tr>
          <tr className="odd">
            <td>
              <span className="label">Real Property.</span>
              <span className="schedule-tips">Copy line 56, Part 9</span>
            </td>
            <td />
            <td className="money" id="property">
              {MoneyFormat(data.property)}
            </td>
          </tr>
          <tr className="even">
            <td>
              <span className="label">Intangibles and intellectual property.</span>
              <span className="schedule-tips">Copy line 66, Part 10</span>
            </td>
            <td className="money" id="intangibles">
              {MoneyFormat(data.intangibles)}
            </td>
            <td />
          </tr>
          <tr className="odd">
            <td>
              <span className="label">All other assets.</span>
              <span className="schedule-tips">Copy line 78, Part 11</span>
            </td>
            <td className="money" id="others">
              {MoneyFormat(data.others)}
            </td>
            <td />
          </tr>
        </tbody>
        <tfoot>
          <tr className="even">
            <td>
              <span className="label">Total</span>
            </td>
            <td className="money subtotal" id="personal">
              {MoneyFormat(data.personal_total || 0)}
            </td>
            <td className="money subtotal" id="real">
              {MoneyFormat(data.real_total || 0)}
            </td>
          </tr>
          <tr className="odd">
            <td>
              <span className="label">Total of all property on Schedule A/B.</span>
            </td>
            <td />
            <td className="money total" id="total">
              {MoneyFormat(data.total || 0)}
            </td>
          </tr>
        </tfoot>
      </React.Fragment>
    );

    return (
      <div>
        <table className="sticky-enabled tablesorter">
          <thead>
            <tr>
              <th>Type of property</th>
              <th>Current value of personal&nbsp;property</th>
              <th>Current value of real&nbsp;property</th>
            </tr>
          </thead>
          {rows}
        </table>
      </div>
    );
  };
  render() {
    const {
      type,
      schedule,
      editScheduleForm,
      canEdit,
      can_see_details,
      onCancel,
      onSubmit,
      onPastedData,
      toggleScheduleForm,
    } = this.props;

    return (
      <div className={type}>
        {can_see_details && (
          <React.Fragment>
            <div id="schedule-ab">
              <div id="ir-search-schedule-ab-results">
                {editScheduleForm ? (
                  <ScheduleABForm
                    {...this.props}
                    // editScheduleForm could be a draft object
                    schedule={
                      editScheduleForm === true
                        ? schedule.data
                          ? schedule
                          : { data: BLANK_FORM_DATA }
                        : editScheduleForm
                    }
                    isDraft={editScheduleForm !== true}
                    onCancel={onCancel}
                    onSubmit={onSubmit}
                  />
                ) : (
                  <React.Fragment>
                    {canEdit && <ScheduleVerifyToolbar schedule={schedule} />}
                    {canEdit && (
                      <EditCopyPasteSchedule
                        schedule={schedule.data ? schedule : { schedule_type: 'ab', data: {} }}
                        onPastedData={onPastedData}
                        toggleScheduleForm={toggleScheduleForm}
                      />
                    )}
                    {this.getScheduleABdata(schedule.data || {})}
                  </React.Fragment>
                )}
                {canEdit && !editScheduleForm && (
                  <div className="editable">
                    <btn className="btn btn-primary" onClick={toggleScheduleForm}>
                      Edit
                    </btn>
                  </div>
                )}
              </div>
            </div>
          </React.Fragment>
        )}
      </div>
    );
  }
}

ScheduleAB.defaultProps = {
  type: 'schedule_ab',
  viewFilters: {},
  keyword: '',
  value_from: '',
  value_to: '',
};

ScheduleAB.propTypes = {
  schedule: PropTypes.any.isRequired,
  type: PropTypes.string,
  viewFilters: PropTypes.object,
  keyword: PropTypes.string,
  value_to: PropTypes.string,
  value_from: PropTypes.string,
  editScheduleForm: PropTypes.bool.isRequired,
  canEdit: PropTypes.bool.isRequired,
  can_see_details: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  toggleScheduleForm: PropTypes.func.isRequired,
};

export default ScheduleAB;



// WEBPACK FOOTER //
// ./src/scheduleform/schedule_ab/ScheduleAB.jsx